import { createFileRoute, redirect } from '@tanstack/react-router';

import { Route as BusinessRoute } from './business';

export const Route = createFileRoute('/_authenticated/claim/$claimId/_claim/')({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: BusinessRoute.to,
			params,
		});
	},
});
